const ROUTES = {
  HOME: '/',
  
  // OctopusSync routes
  OCTOPUSSYNC: '/octopussync',
  OCTOPUSSYNC_FEATURES: '/octopussync/features',
  OCTOPUSSYNC_PRICING: '/octopussync/pricing',
  OCTOPUSSYNC_HOW_TO: '/octopussync/how-to',
  
  // Sentinel routes
  SENTINEL: '/sentinel',
  SENTINEL_FEATURES: '/sentinel/features',
  SENTINEL_PRICING: '/sentinel/pricing', 
  SENTINEL_HOW_TO: '/sentinel/how-to',
  
  // Other pages
  LOGIN: '/login',
  CONTACTS: '/contacts',
  FEATURE_REQUEST: '/feature-request',
  
  NOT_FOUND: '/404'
};

export default ROUTES;
